import React from 'react';
import { ReactComponent as MnhaLogo } from './images/logo.svg';

const Logo = () => <MnhaLogo />;

export default Logo;
